import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { List, Map } from 'immutable';
import {
  formatNumber,
} from './BaseElement.jsx';
import { formatTransportName } from '../transport/SmallTransportDisplay';
import RoleConfigFilter from '../../../auth/RoleConfigFilter.jsx';
import { REF_PATH as BUYER_REF_PATH }
  from '@/component/dict/simple/buyer/Const';
import { REF_PATH as SELLER_REF_PATH }
  from '@/component/dict/simple/supplier/Const';

class ProfitLossTab extends React.Component {
  formatLinkName = (link) => formatTransportName(
    this.props.transportDeals.find(t => t.get('id') == link.split('#')[1]),
    true)

  formatDealName = (dealName = '') => {
    const result = [];
    const dealNameArray = dealName.split('#');
    result.push(<span>{dealNameArray[0] || ''}</span>);
    if (dealNameArray[1] && this.props.sellers && this.props.buyers) {
      const counterparty = this.props[dealNameArray[0]
        .toLowerCase() == 'purchase' ? 'sellers' : 'buyers']
        .find(cp => cp.get('id') == dealNameArray[1]);
      if (counterparty) {
        result.push(<span className="text-primary">{counterparty.get('name', '')}</span>);
      }
    }
    result.push(<span className="profit-loss-deal-name">{dealNameArray[2] || ''}</span>);
    return result;
  }

  renderExpenses = (expenses = new Map()) => {
    const result = [];
    expenses.forEach((value, key) => {
      result.push(<Row className="profit-loss-data" key={key}>
        <Col xs={2} xsOffset={2}>
          {key.split('#')[0]}
        </Col>
        <Col xs={2}>
          {formatNumber(value.bl, '0,0.[000]')}
        </Col>
        <Col xs={2}>
          ${formatNumber(value.estimatedPt, '0,0.00')}
        </Col>
        <Col xs={2}>
          ${formatNumber(value.pt, '0,0.00')}
        </Col>
        <Col xs={2}>
          ${formatNumber((value.pt || 0) * (value.bl || 0), '0,0.00')}
        </Col>
      </Row>);
    });
    return result;
  }


  render() {
    return (
      <RoleConfigFilter permissions={['viewProfitability']}>
        <Row className="profit-loss-tab">
          <Col xs={12} md={12}>
            {this.props.error && <div>Cannot calculate acutal profit: {this.props.error}</div>}
            <div>
              <Row className="profit-loss-header">
                <Col xs={2} />
                <Col xs={2}>
            &nbsp;
                </Col>
                <Col xs={2}>
            B/L Qty
                </Col>
                <Col xs={2}>
            Estimated P/L
                </Col>
                <Col xs={2}>
            Actual P/L
                </Col>
                <Col xs={2}>
            Actual value
                </Col>
              </Row>
              {this.props.data.map((value, link) =>
                <Row key={link}>
                  <Col xs={12} className="profit-loss-link">{this.formatLinkName(link)}</Col>
                  <Col xs={12}>
                    {value.map((expenses, dealName) => <div>
                      <Row>
                        <Col xs={12}className="profit-loss-deal">
                          {this.formatDealName(dealName)}
                        </Col>
                      </Row>
                      {this.renderExpenses(expenses)}
                    </div>
                    )}

                  </Col>
                </Row>
              )}
              {!this.props.isTransport &&
                <Row className="profit-loss-data profit-loss-total">
                  <Col xs={2}>
              PARTIAL P/L
                  </Col>
                  <Col xs={2} >&nbsp;</Col>
                  <Col xs={2}>
                    {formatNumber(this.props.total.get('bl', 0), '0,0.[000]')}
                  </Col>
                  <Col xs={2}>
                    {this.props.total.get('estimated', 0) ?
                      `$${formatNumber(this.props.total.get('estimated', 0), '0,0.00')}`
                      :
                      ''}
                  </Col>
                  <Col xs={2}>
                    {this.props.total.get('actualPT', 0) ?
                      `$${formatNumber(this.props.total.get('actualPT', 0), '0,0.00')}`
                      :
                      ''}
                  </Col>
                  <Col xs={2}>
                    {this.props.total.get('actualLS', 0) ?
                      `$${formatNumber(this.props.total.get('actualLS', 0), '0,0.00')}`
                      :
                      ''}
                  </Col>
                </Row>
              }
              {(this.props.showGrandTotal || this.props.isTransport) &&
                <Row className="profit-loss-data profit-loss-total profit-loss-deal-total">
                  <Col xs={2}>
                CONTRACT P/L
                  </Col>
                  <Col xs={2} >&nbsp;</Col>
                  <Col xs={2}>
                    {formatNumber(this.props.dealTotal.get('bl', 0), '0,0.[000]')}
                  </Col>
                  <Col xs={2}>
                    {this.props.dealTotal.get('estimated', 0) != 'N/A' ?
                      `$${formatNumber(this.props.dealTotal.get('estimated', 0), '0,0.00')}`
                      :
                      ''}
                  </Col>
                  <Col xs={2}>
                    {this.props.dealTotal.get('actualPT', 0) != 'N/A' ?
                      `$${formatNumber(this.props.dealTotal.get('actualPT', 0), '0,0.00')}`
                      :
                      ''}
                  </Col>
                  <Col xs={2}>
                    {this.props.dealTotal.get('actualLS', 0) != 'N/A' ?
                      `$${formatNumber(this.props.dealTotal.get('actualLS', 0), '0,0.00')}`
                      :
                      ''}
                  </Col>
                </Row>
              }
            </div>
          </Col>
        </Row>
      </RoleConfigFilter>);
  }
}
ProfitLossTab.propTypes = {
  data: React.PropTypes.object,
  dealTotal: React.PropTypes.object,
  total: React.PropTypes.object,
  transportDeals: React.PropTypes.object,
  error: React.PropTypes.string,
  rightSide: React.PropTypes.bool,
  showGrandTotal: React.PropTypes.bool,
  isTransport: React.PropTypes.bool,
  sellers: React.PropTypes.object,
  buyers: React.PropTypes.object,
};
export default connect((state, props) => ({
  data: state.getIn(['data', 'deals', 'pltab', props.id, 'expenses'], new List()),
  total: state.getIn(['data', 'deals', 'pltab', props.id, 'total'], new Map()),
  dealTotal: state.getIn(['data', 'deals', 'pltab', 'deal', 'total'], new Map()),
  transportDeals: state.getIn(['data', 'deals', 'list', 'transport']),
  error: state.getIn(['data', 'deals', 'pltab', 'error', props.id]),
  buyers: state.getIn(['references', 'simple', BUYER_REF_PATH], new List()),
  sellers: state.getIn(['references', 'simple', SELLER_REF_PATH], new List()),
})
)(ProfitLossTab);
